<template>
    <section class="steps">
        <ul class="steps__way-list">
            <li class="steps__way-item" :class="{ _active: firstStep }">
                <span>1</span>
            </li>
            <li class="steps__way-item" :class="{ _active: secondStep }">
                <span>2</span>
            </li>
            <li class="steps__way-item" :class="{ _active: thirdStep }">
                <span>3</span>
            </li>
            <li class="steps__way-item" :class="{ _active: fourStep }">
                <span>4</span>
            </li>
            <li class="steps__way-item" :class="{ _active: fiveStep }">
                <span>5</span>
            </li>
        </ul>
        <div class="steps__inner">
            <div class="steps__list">
                <section v-if="firstStep" class="steps__item first-step">
                    <h2 class="title">Шаг 1</h2>
                    <p class="sub-title">Размеры</p>
                    <p class="steps__item__text">
                        Замер ширины предполагаемого места размещения изделия производится с точностью до 1 см.
                    </p>
                    <div class="first-step__inner">
                        <img class="first-step__img"
                             :src="(defaultwindow != '') ? defaultwindow : '/assets/img/card/size.jpg'" alt="">
                        <div class="first-step__wrapper">
                            <label for="constructorWidth" class="first-step__label">
                                <span class="first-step__desc">Ширина, см</span>
                                <span class="first-step__input-inner">
                                    <svg class="icon">
                                        <use xlink:href="#window-width"/>
                                    </svg>
                                    <input class="first-step__input" type="text" @keyup="colorsBySize"
                                           id="constructorWidth"
                                           placeholder="100" v-model="constructor.width">
                                </span>
                            </label>
                            <label for="constructorHeight" class="first-step__label">
                                <span class="first-step__desc">Высота, см</span>
                                <span class="first-step__input-inner">
                                    <svg class="icon">
                                        <use xlink:href="#window-height"/>
                                    </svg>
                                    <input class="first-step__input" type="text" @keyup="colorsBySize"
                                           id="constructorHeight"
                                           placeholder="100" v-model="constructor.height">
                                </span>
                            </label>
                        </div>
                    </div>
                    <h2 class="sub-title">Выберите цвет комплектации</h2>
                    <p class="steps__item__text" v-if="colorItems.length === 0">
                        Укажите размер
                    </p>
                    <div class="first-step__colors" v-else>
                        <div v-for="(colorItem, id) of colorItems"
                             class="first-step__colors-item radio _onlyIcon"
                             :class="{_image: colorItem.image !== null}">
                            <img :src="colorItem.image"
                                 alt=""
                                 class="first-step__colors-item-img"
                                 v-if="colorItem.image !== null"
                                 width="120" height="120">
                            <input :id="id + 'colorItem'" type="radio"
                                   v-model="constructor.color"
                                   @change="setColor"
                                   ref="color"
                                   :value="colorItem.id"
                                   class="first-step__colors-item radio__input" name="colorItems">
                            <label class="radio__label link" :class="{_shadow: colorItem.shadow}"
                                   :title="colorItem.name"
                                   :for="id + 'colorItem'" :style="{'--checkboxColorBg': colorItem.color}">
                                <span class="first-step__colors-item-text" v-if="colorItem.image !== null">
                                    {{ colorItem.name }}
                                </span>
                            </label>
                        </div>
                    </div>
                    <div class="steps__btn-inner">
                        <button class="btn" @click="getSecondStep" v-if="firstStepBtn">Продолжить</button>
                        <p v-if="!firstStepBtn">Пожалуйста, укажите корректные размеры окна</p>
                    </div>
                </section>
                <section v-if="secondStep" class="steps__item second-step">
                    <h2 class="title">Шаг 2</h2>
                    <p class="sub-title">Материалы</p>
                    <p class="steps__item__text">
                        Выберите материал: кликните по понравившейся ткани и посмотрите как она будет смотреться на
                        окне. Затем нажмите продолжить.
                    </p>
                    <div class="second-step__inner" v-if="fabrics.length > 0">
                        <div class="second-step__clothes">
                            <h3 class="steps__subtitle">Ткань:</h3>
                            <div class="tags">
                                <button :class="'tags__item'+(category.active ? ' _active' : '')"
                                        @click="filterByCategory('fabricCategories', 'fabrics', i, category.id)"
                                        type="button" v-for="(category, i) in fabricCategories">
                                    {{ category.name }}
                                </button>
                            </div>
                            <div class="second-step__clothes-inner">
                                <section class="second-step__clothes-item" v-for="fabric in fabricsWithLimit"
                                         @click="setFabric(fabric.id, 'fabric')">
                                    <span class="second-step__clothes-sale" v-if="fabric.discount">-{{
                                            fabric.discount
                                        }}%</span>
                                    <img class="second-step__clothes-item-img"
                                         :src="fabric.image_url" :alt="fabric.front_name + 'фото'">
                                    <p class="second-step__clothes-item-name">{{ fabric.front_name }}</p>
                                    <p class="second-step__clothes-item-price">
                                        <span v-if="fabric.discount">{{
                                                formatPrice(fabric.price_by_context * ((100 - fabric.discount) / 100))
                                            }} руб</span>
                                        <span v-else>{{ fabric.price_by_context }} руб</span>
                                        <sup v-if="fabric.discount">{{ fabric.price_by_context }} руб</sup>
                                    </p>
                                </section>
                            </div>
                        </div>
                        <button class="btn second-step__more" type="button" v-if="fabricsFiltered > fabricsWithLimit"
                                @click="loadMoreFabrics(10)">Показать больше
                        </button>
                    </div>
                    <div class="second-step__inner" v-if="prints.length > 0">
                        <div class="second-step__clothes">
                            <h3 class="steps__subtitle">Принты:</h3>
                            <div class="tags">
                                <button :class="'tags__item'+(category.active ? ' _active' : '')"
                                        @click="filterByCategory('printCategories', 'prints', i, category.id)"
                                        type="button" v-for="(category, i) in printCategories">
                                    {{ category.name }}
                                </button>
                            </div>
                            <div class="second-step__clothes-inner">
                                <div class="second-step__clothes-item"
                                     v-for="fabric in printsWithLimit"
                                     @click="setFabric(fabric.id)">
                                    <span class="second-step__clothes-sale" v-if="fabric.discount">-{{
                                            fabric.discount
                                        }}%</span>
                                    <img class="second-step__clothes-item-img"
                                         :src="fabric.image_url" :alt="fabric.front_name + 'фото'">
                                    <p class="second-step__clothes-item-name">{{ fabric.front_name }}</p>
                                    <p class="second-step__clothes-item-price">
                                        <span v-if="fabric.discount">{{
                                                formatPrice(fabric.price_by_context * ((100 - fabric.discount) / 100))
                                            }} руб</span>
                                        <span v-else>{{ fabric.price_by_context }} руб</span>
                                        <sup v-if="fabric.discount">{{ fabric.price_by_context }} руб</sup>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <button class="btn second-step__more" type="button" v-if="printsFiltered > printsWithLimit"
                                @click="loadMorePrints(10)">Показать больше
                        </button>
                    </div>
                    <div class="second-step__inner" v-if="photoprints.length > 0">
                        <div class="second-step__clothes">
                            <h3 class="steps__subtitle">Фотопечать:</h3>
                            <div class="tags">
                                <button :class="'tags__item'+(category.active ? ' _active' : '')"
                                        @click="filterByCategory('photoprintCategories', 'photoprints', i, category.id)"
                                        type="button" v-for="(category, i) in photoprintCategories">
                                    {{ category.name }}
                                </button>
                            </div>
                            <div class="second-step__clothes-inner">
                                <div class="second-step__clothes-item" v-for="fabric in photoprintsWithLimit"
                                     @click="setFabric(fabric.id)" :class="{_active : activeClothes}">
                                    <span class="second-step__clothes-sale" v-if="fabric.discount">-{{
                                            fabric.discount
                                        }}%</span>
                                    <img class="second-step__clothes-item-img lazy"
                                         :src="fabric.image_url" :alt="fabric.front_name + 'фото'">
                                    <p class="second-step__clothes-item-name">{{ fabric.front_name }}</p>
                                    <p class="second-step__clothes-item-price">
                                        <span v-if="fabric.discount">{{
                                                formatPrice(fabric.price_by_context * ((100 - fabric.discount) / 100) + fabric.photoprint_price)
                                            }} руб</span>
                                        <span v-else>{{ fabric.price_by_context }} руб</span>
                                        <sup v-if="fabric.discount">{{ fabric.price_by_context }} руб</sup>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <button class="btn second-step__more" type="button"
                                v-if="photoprintsFiltered > photoprintsWithLimit" @click="loadMorePhotoprints(10)">
                            Показать больше
                        </button>
                    </div>
                    <div class="steps__btn-inner">
                        <button class="btn _border" @click="getFirstStep">Назад</button>
                        <button class="btn" @click="getThirdStep" v-if="secondStepBtn">Продолжить</button>
                        <p v-if="!secondStepBtn">Выберите ткань</p>
                        <button class="btn second-step__goToClothes" @click="scrollToClothes"
                                v-if="clothesScrollStatus">
                            Вернуться к ткани
                        </button>
                    </div>
                </section>
                <section v-if="thirdStep" class="steps__item third-step">
                    <h2 class="title">Шаг 3</h2>
                    <p class="sub-title">Тип управления</p>
                    <p class="steps__item__text">
                        Выберите тип управления и нажмите продолжить
                    </p>
                    <div class="third-step__inner">
                        <div class="third-step__item" v-for="(driver, id) of drivers" :key="id">
                            <img class="third-step__item-img"
                                 :src="driver.custom_image ? driver.custom_image : driver.image_url"
                                 :alt="driver.name + 'фото'">
                            <div class="radio _small">
                                <input class="radio__input radio-second__input" type="radio"
                                       @change="setDriverType(driver.id)"
                                       v-model="mDriverType"
                                       :value="driver.id"
                                       :id="id + 'controlItem'" name="controlItem">
                                <label class="radio__label radio-second__label link link" :for="id + 'controlItem'">
                                    {{ driver.name }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <h3 class="steps__subtitle" v-if="options.length > 0">Дополнительные варианты управления:</h3>
                    <div class="third-step__inner">
                        <div class="third-step__item" v-for="(option, id) of options">
                            <img class="third-step__item-img" :src="option.image_url"
                                 :alt="option.name + 'фото'">
                            <div class="checkbox">
                                <input class="checkbox__input" type="checkbox"
                                       @change="setOptions(option.id)"
                                       v-model="mOptions"
                                       :value="option.id"
                                       :id="id + 'controlPayItem'" name="controlPayItem">
                                <label class="checkbox__label link" :for="id + 'controlPayItem'">
                                    {{ option.name }}
                                    <strong>{{ option.price }} руб</strong>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="steps__btn-inner">
                        <button class="btn _border" @click="getSecondStep">Назад</button>
                        <button class="btn" @click="getFourStep" v-if="mDriverType !== null">Продолжить</button>
                        <p v-if="mDriverType === null">Выберите тип управления</p>
                    </div>
                </section>
                <section v-if="fourStep" class="steps__item four-step">
                    <h2 class="title">Шаг 4</h2>
                    <p class="sub-title">Место крепления</p>
                    <p class="steps__item__text">
                        Выберите место крепления  на окне и перейдите в корзину
                    </p>
                    <div class="four-step__inner">
                        <div class="four-step__item" v-for="(place, id) of placements">
                            <img class="four-step__item-img"
                                 :src="place.custom_image ? place.custom_image : place.image_url"
                                 :alt="place.name + 'фото'">
                            <div class="radio _small">
                                <input class="radio__input radio-second__input" type="radio"
                                       @change="setPlacement(place.id)"
                                       v-model="mPlacement"
                                       :value="place.id"
                                       :id="id + 'attachPoint'" name="attachPoint">
                                <label class="radio__label radio-second__label link link" :for="id + 'attachPoint'">
                                    {{ place.name }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="steps__btn-inner">
                        <button class="btn _border" @click="getThirdStep">Назад</button>
                        <button class="btn" @click="getFiveStep" v-if="mPlacement !== null">Продолжить</button>
                        <p v-if="mPlacement === null">Выберите тип крепления</p>
                    </div>
                </section>
                <section v-if="fiveStep" class="steps__item five-step">
                    <h2 class="title">Шаг 5</h2>
                    <p class="sub-title">Параметры вашего изделия</p>
                    <div class="five-step__inner">
                        <div class="five-step__item">
                            <span class="five-step__item-term">Изделие:</span>
                            <span class="five-step__item-desc" v-if="name">{{ name }}</span>
                        </div>
                        <div class="five-step__item">
                            <span class="five-step__item-term">Размер (Ш х В, см):</span>
                            <span class="five-step__item-desc">{{ constructor.width }}х{{ constructor.height }}</span>
                        </div>
                        <div class="five-step__item">
                            <span class="five-step__item-term">Цвет комплектации:</span>
                            <span class="five-step__item-desc">{{ product.color.name }}</span>
                        </div>
                        <div class="five-step__item">
                            <span class="five-step__item-term">Материал:</span>
                            <span class="five-step__item-desc">{{ product.fabric.front_name }}</span>
                        </div>
                        <div class="five-step__item">
                            <span class="five-step__item-term">Тип управления:</span>
                            <span class="five-step__item-desc">{{ product.driverType.name }}</span>
                        </div>
                        <div class="steps-total__item" v-if="product.options.length > 0">
                            <span class="steps-total__item-term">Опции</span>
                            <span class="steps-total__item-desc _active"
                                  v-for="option in product.options">{{ option.name }} +{{ formatPrice(option.price) }} руб.</span>
                        </div>
                        <div class="five-step__item">
                            <span class="five-step__item-term">Место крепления:</span>
                            <span class="five-step__item-desc">{{ product.placement.name }}</span>
                        </div>
                        <div class="five-step__item _sum">
                            <span class="five-step__item-term">Цена:</span>
                            <span class="five-step__item-desc">{{ product.price }} руб</span>
                        </div>
                    </div>
                    <div class="steps__btn-inner">
                        <button class="btn _border" @click="getFourStep">Назад</button>
                        <button class="btn add-cart" @click="toCart">
                            <span class="add-cart__text">Добавить в корзину</span>
                            <span class="cart">
                                <svg viewBox="0 0 36 26">
                                    <polyline points="1 2.5 6 2.5 10 18.5 25.5 18.5 28.5 7.5 7.5 7.5"></polyline>
                                    <polyline points="15 13.5 17 15.5 22 10.5"></polyline>
                                </svg>
                            </span>
                        </button>
                    </div>
                </section>
            </div>
            <div class="steps-total js-steps-total">
                <div class="steps-total__img" v-if="windowWidth >= 992">
                    <img v-if="product.fabric.product_original_image_url" ref="img"
                         v-simple-magnifier
                         :src="product.fabric.product_original_image_url">
                    <img v-else
                         :src="defaultimg"
                         alt="">
                </div>
                <div class="steps-total__img _special" v-else>
                    <img v-if="product.fabric.product_original_image_url" ref="img"
                         :src="product.fabric.product_original_image_url">
                    <img v-else
                         :src="defaultimg"
                         alt="">
                </div>
                <div class="steps-total__inner">
                    <div class="steps-total__item _active">
                        <span class="steps-total__item-term">Изделие:</span>
                        <span class="steps-total__item-desc" v-if="name">{{ name }}</span>
                    </div>
                    <div class="steps-total__item _active">
                        <span class="steps-total__item-term">Размер (Ш х В, см):</span>
                        <span class="steps-total__item-desc">
                            {{ constructor.width }}х{{ constructor.height }}
                        </span>
                    </div>
                    <div :class="'steps-total__item'+(product.color.id ? ' _active' : '')">
                        <span class="steps-total__item-term">Цвет комплектации:</span>
                        <span class="steps-total__item-desc">{{ product.color.name }}</span>
                    </div>
                    <div :class="'steps-total__item'+(product.fabric.id ? ' _active' : '')">
                        <span class="steps-total__item-term">Материал:</span>
                        <span class="steps-total__item-desc _active">{{ product.fabric.front_name }}</span>
                    </div>
                    <div :class="'steps-total__item'+( product.driverType.id ? ' _active' : '')">
                        <span class="steps-total__item-term">Тип управления:</span>
                        <span class="steps-total__item-desc _active">{{ product.driverType.name }}</span>
                    </div>
                    <div class="steps-total__item _active" v-if="product.options.length > 0">
                        <span class="steps-total__item-term">Опции</span>
                        <div class="steps-total__item-term-inner">
                            <span class="steps-total__item-desc _active" v-for="option in product.options">
                                {{ option.name }} +{{ formatPrice(option.price) }} руб.
                            </span>
                        </div>
                    </div>
                    <div :class="'steps-total__item'+( product.placement.id ? ' _active' : '')">
                        <span class="steps-total__item-term">Место крепления:</span>
                        <span class="steps-total__item-desc _active">{{ product.placement.name }}</span>
                    </div>
                    <div class="steps-total__sum">
                        <span class="steps-total__sum-item">Цена:</span>
                        <span class="steps-total__sum-item">{{ product.price }} руб.</span>
                    </div>
                </div>
            </div>
            <transition name="overlay">
                <div class="cart-bg" v-if="showAddToCart" @click="hideAddToCart">
                    <span class="cart-bg__text"> Товар добавлен в корзину</span>
                </div>
            </transition>
        </div>
    </section>
</template>

<script>
import VSimpleMagnifier from 'v-simple-magnifier';
import SimpleLightbox from 'simple-lightbox';

export default {
    name: 'MainConstructor',
    components: {VSimpleMagnifier, SimpleLightbox},
    props: ['id', 'name', 'defaultimg', 'defaultwindow'],
    mounted() {
        this.colorsBySize();
        this.setDriverType();
        window.addEventListener('scroll', this.stickyConstructorTotal, {passive: true});
        window.addEventListener('scroll', this.handleResize, {passive: true});
    },
    created() {
        window.addEventListener('scroll', this.handleResize, {passive: true});
    },
    destroyed() {
        window.addEventListener('scroll', this.handleResize, {passive: true});
    },
    methods: {
        loadMoreFabrics(limit) {
            this.fabricsLimit += limit;
        },
        loadMorePrints(limit) {
            this.printsLimit += limit;
        },
        loadMorePhotoprints(limit) {
            this.photoprintsLimit += limit
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
        },
        colorsBySize() {
            this.$http.post('/api/products/' + this.id + '/builder/set', this.constructor)
                .then(res => {
                    this.colorItems = res.data.available.colors;
                    this.product = res.data.product;
                    this.$nextTick(() => {
                        this.$refs.color[0].dispatchEvent(new Event("change"));
                    });
                    this.firstStepBtn = true;
                })
                .catch(error => {
                    this.firstStepBtn = false;
                });
        },
        setColor() {
            this.$http.post('/api/products/' + this.id + '/builder/set', this.constructor)
                .then(res => {
                    this.colorItems = res.data.available.colors;
                    this.fabrics = res.data.available.fabrics;
                    this.fabricsFiltered = res.data.available.fabrics;
                    this.fabricCategories = res.data.available.fabricCategories;
                    this.prints = res.data.available.prints;
                    this.printsFiltered = res.data.available.prints;
                    this.printCategories = res.data.available.printCategories;
                    this.photoprints = res.data.available.photoprints;
                    this.photoprintsFiltered = res.data.available.photoprints;
                    this.photoprintCategories = res.data.available.photoprintCategories;
                    this.product = res.data.product;
                })
                .catch(error => {
                    this.firstStepBtn = false;
                });

        },
        setFabric(id, type = null) {
            let constructorTotal = document.querySelector('.js-steps-total'),
                constructorTotalTop = constructorTotal.getBoundingClientRect().top + pageYOffset;
            if (window.innerWidth <= 992) {
                this.clothesPosition = window.scrollY;
                window.scrollTo(0, constructorTotalTop);
                this.clothesScrollStatus = true;
            }

            this.constructor.fabric = id;
            this.constructor.fabricType = type;
            this.activeClothes = true;
            this.secondStepBtn = true;
            this.$http.post('/api/products/' + this.id + '/builder/set', this.constructor)
                .then(res => {
                    this.product = res.data.product;
                    this.drivers = res.data.available.driverTypes;
                    this.$nextTick(() => {
                        if (this.$refs.img && this.product.fabric.product_original_image_url && this.windowWidth >= 992) {
                            this.$refs.img._magnifierDirective.updateBinding(this.$refs.img._magnifierDirective.el, {});
                        }
                    });
                });
        },
        setDriverType(id) {
            this.constructor.activeOptions = [];
            this.mOptions = [];
            this.constructor.driverType = id;
            this.$http.post('/api/products/' + this.id + '/builder/set', this.constructor).then(res => {
                this.product = res.data.product;
                this.options = res.data.available.options;
                this.placements = res.data.available.placements;
                this.$nextTick(() => {
                    //console.log(this.drivers[0]);
                });
            });
        },
        setOptions(id) {
            const index = this.constructor.activeOptions.indexOf(id);
            if (index > -1) {
                this.constructor.activeOptions.splice(index, 1);
            } else {
                this.constructor.activeOptions.push(id);
            }
            this.$http.post('/api/products/' + this.id + '/builder/set', this.constructor).then(res => {
                this.product = res.data.product;
            });
        },
        setPlacement(id) {
            this.constructor.placement = id;
            this.$http.post('/api/products/' + this.id + '/builder/set', this.constructor).then(res => {
                this.product = res.data.product;
            });
        },
        toCart() {
            this.$http.post('/api/cart/composite/' + this.id, this.constructor).then(res => {
                this.$eventBus.$emit('cart.increase');
            });
            this.showAddToCart = true;
            document.body.classList.add('_no-scroll');
            setTimeout(() => {
                location.replace('/cart/order');
            }, 1500)
        },
        hideAddToCart() {
            this.showAddToCart = false;
            document.body.classList.remove('_no-scroll');
        },
        formatPrice(p) {
            return new Intl.NumberFormat('ru-RU').format(p)
        },
        filterByCategory(type, category, i, id) {
            this[type].forEach((e) => e.active = false);
            this[type][i].active = true;
            this.$nextTick(() => {
                if (id != 0) {
                    this[category + 'Filtered'] = this[category].filter((el) => {
                        return el.fabric.tag_filter.includes(id);
                    })
                } else {
                    this[category + 'Filtered'] = this[category];
                }
            })
        },
        getFirstStep() {
            this.constructor.fabric = null;
            this.product.fabric = {
                front_name: 'выберите материал'
            };
            let stepsList = document.querySelector('.steps__list');
            this.firstStep = true;
            this.secondStep = false;
            window.scroll(0, stepsList.offsetTop - 60);
        },
        getSecondStep() {
            this.mDriverType = null;
            this.constructor.driverType = null;
            this.mOptions = [];
            this.options = [];
            this.product.driverType = {
                name: 'выберите тип управления'
            };
            this.product.options = [];
            this.constructor.activeOptions = [];
            this.$http.post('/api/products/' + this.id + '/builder/set', this.constructor).then(res => {
                this.product = res.data.product;
            })
            let stepsList = document.querySelector('.steps__list');
            this.firstStep = false;
            this.secondStep = true;
            this.thirdStep = false;
            window.scroll(0, stepsList.offsetTop - 60);
        },
        getThirdStep() {
            this.mPlacement = null;
            this.product.placement = {
                name: 'выберите место крепления'
            };
            this.constructor.placement = null;
            let stepsList = document.querySelector('.steps__list');
            this.secondStep = false;
            this.thirdStep = true;
            this.fourStep = false;
            window.scroll(0, stepsList.offsetTop - 60);
        },
        getFourStep() {
            let stepsList = document.querySelector('.steps__list');
            this.thirdStep = false;
            this.fourStep = true;
            this.fiveStep = false;
            window.scroll(0, stepsList.offsetTop - 60);
        },
        getFiveStep() {
            let stepsList = document.querySelector('.steps__list');
            this.fourStep = false;
            this.fiveStep = true;
            window.scroll(0, stepsList.offsetTop - 60);
        },
        stickyConstructorTotal() {
            this.$nextTick(function () {
                this.scrollPosition = window.scrollY;
                let constructorTotal = document.querySelector('.js-steps-total');
                if (window.innerWidth >= 992 && this.scrollPosition > 410) {
                    constructorTotal.classList.add("_sticky");
                } else {
                    constructorTotal.classList.remove("_sticky");
                }
            });
        },
        scrollToClothes() {
            this.clothesScrollStatus = false;
            window.scroll(0, this.clothesPosition);
        }
    },
    computed: {
        fabricsWithLimit: function () {
            return this.fabricsFiltered.slice(0, this.fabricsLimit);
        },
        printsWithLimit: function () {
            return this.printsFiltered.slice(0, this.printsLimit);
        },
        photoprintsWithLimit: function () {
            return this.photoprintsFiltered.slice(0, this.photoprintsLimit);
        }
    },
    data() {
        return {
            scrollPosition: null,
            footerHeight: null,
            windowWidth: null,
            clothesPosition: null,
            clothesScrollStatus: false,
            showAddToCart: false,
            constructor: {
                width: 40,
                height: 140,
                activeOptions: [],
            },
            placements: [],
            product: {
                price: 0,
                color: {
                    name: 'выберите цвет'
                },
                fabric: {
                    front_name: 'выберите материал'
                },
                driverType: {
                    name: 'выберите тип управления'
                },
                placement: {
                    name: 'выберите место крепления'
                },
                options: []
            },
            mOptions: [],
            mPlacement: null,
            mDriverType: null,
            activeClothes: null,
            firstStep: true,
            firstStepBtn: false,
            secondStep: false,
            secondStepBtn: false,
            thirdStep: false,
            fourStep: false,
            fiveStep: false,
            drivers: [],
            options: [],
            colorItems: [],
            fabrics: [],
            fabricsFiltered: [],
            fabricsLimit: 20,
            fabricCategories: [],
            prints: [],
            printsFiltered: [],
            printCategories: [],
            printsLimit: 20,
            photoprints: [],
            photoprintsFiltered: [],
            photoprintCategories: [],
            photoprintsLimit: 20,
            clothesItems: [],
        }
    },
}
</script>
